import services from 'api/services';
import { logError } from 'util/errors';
import { Images } from 'util/images';

import {
  GET_ME_REQUEST,
  GET_ME_SUCCESS,
  GET_ME_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  SET_PROFILE,
  CLEAR_ERROR,
  CLEAR_STATE,
} from './constants';

const { AuthService } = services;

export const clearState = () => (dispatch) => {
  dispatch({ type: CLEAR_STATE });
};

export const clearError = () => (dispatch) => {
  dispatch({ type: CLEAR_ERROR });
};

export const getProfile = (id) => async (dispatch) => {
  try {
    dispatch({ type: id ? GET_USER_REQUEST : GET_ME_REQUEST });
    const {
      user,
      challenges,
      tournaments,
      exercises,
      trophies,
      activities,
      totalNumberOfAchievements,
      completedAchievements,
      latestCompletedAchievement,
      level,
      totalXp,
      xpForLevel,
      xpInThisLevel,
    } = await AuthService.getProfile(id);
    if (user.avatar === '/images/placeholder-avatar.png') {
      user.avatar = Images.defaultAvatar;
    }
    dispatch({
      type: id ? GET_USER_SUCCESS : GET_ME_SUCCESS,
      profile: user,
      challenges,
      tournaments,
      exercises,
      trophies,
      activities,
      totalNumberOfAchievements,
      completedAchievements,
      latestCompletedAchievement,
      level,
      totalXp,
      xpForLevel,
      xpInThisLevel,
    });
  } catch (ex) {
    logError(ex);
    dispatch({ type: id ? GET_USER_FAILURE : GET_ME_FAILURE, error: ex.message });
  }
};

export const setProfile = (field, value, isNotCommunity) => (dispatch) => {
  dispatch({ type: SET_PROFILE, field, value, isNotCommunity });
};

export const updateUser = (body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_USER_REQUEST });
    const { xpToast } = await AuthService.updateUser(body);
    dispatch({ type: UPDATE_USER_SUCCESS });
    if (xpToast) return xpToast;
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_USER_FAILURE, error: ex.message });
  }
};
